class RouteSummaryStopsRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteSummaryStops";

    super(entityName);

    this.fieldsToProjection = [];
    var options = Monet.Grid.Utils.paginationOptions;
    if (!App.Forms.RouteSummaryStops) {
      App.Forms.RouteSummaryStops = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [{ field: "stop.plannedSequenceNum", order: "ASC" }],
        routeId: null,
        controlUpdater: null
      };
    }

    if (!App.Objects.RouteSummaryStops) {
      App.Objects.RouteSummaryStops = this;
    }
  }

  updateGrid = (filter, callback, appendCollection, action) => {
    var error = null,
      that = this,
      _filter = {},
      columns = [],
      stopCollection = null,
      projectionBuilder = null,
      addPaginationGrid = true,
      pagination = {},
      prefix = "stop.",
      processProjection = "",
      fieldsTransient = [
        "baselineServiceTime",
        "plannedServiceTime",
        "actualServiceTime"
      ];

    try {
      if (filter) {
        _filter = filter;
      }

      columns = App.Forms.RouteSummaryStops.table.getColumns();
      filter = App.Forms.RouteSummaryStops.filterBuilder;

      if (action === "update") {
        var firstResult = 0;
        var updater;
        var page;
        var pages;
        var options;

        options = Monet.Grid.Utils.paginationOptions;
        updater = App.Forms.RouteSummaryStops.controlUpdater;

        page = updater.getPageByScrollPosition();

        pages = updater.getPages();

        if (page !== 0) {
          firstResult = pages[page].firstResult;
        }

        pagination.first = firstResult;
        pagination.max = options.MAX_RESULT;
      } else {
        pagination = App.Forms.RouteSummaryStops.pagination;
      }

      stopCollection = new App.Collections.StopViews();
      projectionBuilder = new Monet.Builder.Projection();

      projectionBuilder.setLayout(App.Forms.RouteSummaryStops.layout.index);
      projectionBuilder.parseLayout();
      projectionBuilder.addField({ name: "stop.id" });
      projectionBuilder.addField({ name: "stop.key" });
      projectionBuilder.addField({ name: "stop.actualArrival" });
      projectionBuilder.addField({ name: "stop.actualDeparture" });
      projectionBuilder.addField({ name: "stop.confirmedAsNextStop" });
      projectionBuilder.addField({ name: "stop.projectedArrival" });
      projectionBuilder.addField({ name: "stop.cancelCode.id" });
      projectionBuilder.addField({ name: "stop.undeliverableCode.id" });
      projectionBuilder.addField({ name: "stop.redeliveryStop.id" });
      projectionBuilder.addField({ name: "stop.cloneDate" });
      projectionBuilder.addField({
        name: "stop.stopType",
        lookupEntityColumn: "type"
      });
      projectionBuilder.addField({ name: "stop.firstStop" });
      projectionBuilder.addField({ name: "stop.deliveryStatus" });
      projectionBuilder.addField({ name: "route.id" });
      projectionBuilder.addField({ name: "route.key" });
      projectionBuilder.addField({ name: "route.hasPicture" });
      projectionBuilder.setPagination(pagination);
      projectionBuilder.addFieldsTransient(fieldsTransient);

      processProjection = projectionBuilder.projection.toString();

      if (appendCollection) {
        stopCollection.reset();
      }

      filter.filterButton.showLoading();
      App.Forms.RouteSummaryStops.pagination.blocked = true;

      stopCollection.filterWithRestrictions({
        filter: _filter,
        criteria: processProjection,
        restrictionUrl: "/Summary",
        success: result => {
          if (callback) {
            callback(that.entityName, columns, result, addPaginationGrid);
          }
          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteSummaryStops.pagination.blocked = false;
        },
        error: result => {
          App.Views.RouteSummary.showAlertMessageError(result);
          callback(that.entityName, columns, stopCollection, addPaginationGrid);
          filter.loading.hide();
          filter.filterButton.hideLoading();
          App.Forms.RouteSummaryStops.pagination.blocked = false;
        }
      });
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring stops",
        e
      );
      error.console();
    }
  };

  updateSideBar = () => {
    var sideBar = Greenmile.RouteSummary.SideBar.getSideBar();
    sideBar.innerHTML = "";
  };

  getCriteriaToFilterFromReports = filter => {
    const hasPlannedSize1 = {
      attr: "stop.plannedSize1",
      isNull: false
    };
    const canceled = {
      attr: "stop.cancelCode.id",
      isNull: false
    };
    const notCanceled = {
      attr: "stop.cancelCode.id",
      isNull: true
    };
    const redelivered = {
      attr: "stop.redeliveryStop.id",
      isNull: false
    };
    const notRedelivered = {
      attr: "stop.redeliveryStop.id",
      isNull: true
    };
    const notUndelivered = {
      attr: "stop.undeliverableCode.id",
      isNull: true
    };
    const undelivered = {
      attr: "stop.undeliverableCode.id",
      isNull: false
    };
    const departed = {
      attr: "stop.actualDeparture",
      isNull: false
    };
    const noSignature = {
      attr: "stopSignature.id",
      isNull: true
    };
    const hasSignature = {
      attr: "stopSignature.id",
      isNull: false
    };
    const signatureWithoutCoord = {
      attr: "stopSignature.latitude",
      isNull: true
    };
    const noArrivalLatitude = {
      attr: "stop.arrivalLatitude",
      isNull: true
    };
    const newOrder = {
      attr: "stop.orders.newOrder",
      eq: true
    };
    const isNotNewOrder = {
      attr: "stop.orders.newOrder",
      isNull: true
    };
    const serviceRated = {
      attr: "stopSignature.rating",
      isNull: false
    };
    const serviceNotRated = {
      attr: "stopSignature.rating",
      isNull: true
    };
    const worstService = {
      attr: "stopSignature.rating",
      leq: 2
    };
    const ratingIsNotNull = {
      attr: "stopSignature.rating",
      isNull: false
    };
    const signatureIsInConformity = {
      attr: "stop.signatureConformity",
      eq: "Y"
    };
    const signatureIsNotInConformity = {
      attr: "stop.signatureConformity",
      eq: "N"
    };

    switch (filter) {
      case "planned":
        return [hasPlannedSize1, notRedelivered];
      case "delivered":
        return [
          hasPlannedSize1,
          notRedelivered,
          notCanceled,
          notUndelivered,
          departed
        ];
      case "canceled":
        return [hasPlannedSize1, notRedelivered, canceled];
      case "undelivered":
        return [hasPlannedSize1, notRedelivered, undelivered];
      case "nosignature":
        return [
          hasPlannedSize1,
          notRedelivered,
          noSignature,
          noArrivalLatitude
        ];
      case "signaturewithoutcoord":
        return [
          hasPlannedSize1,
          notRedelivered,
          hasSignature,
          signatureWithoutCoord,
          noArrivalLatitude
        ];
      case "redelivered":
        return [redelivered];
      case "resale":
        return [notRedelivered, newOrder];
      case "servicerating":
        return [notRedelivered, serviceRated, isNotNewOrder];
      case "noservicerating":
        return [notRedelivered, serviceNotRated, isNotNewOrder];
      case "worstservice":
        return [notRedelivered, worstService, isNotNewOrder, ratingIsNotNull];
      case "signatureisinconformity":
        return [notRedelivered, signatureIsInConformity];
      case "signatureisnotinconformity":
        return [notRedelivered, signatureIsNotInConformity];
      default:
        return [];
    }
  };

  getFilter = () => {
    let criteria = {};
    const filterBuilder = App.Forms.RouteSummaryStops.filterBuilder;

    if (filterBuilder) {
      criteria = filterBuilder.getCriteriaChain();
    }

    if (App.Forms.RouteSummaryStops.filterFromReports) {
      const {
        filter,
        routeId,
        stopKey
      } = App.Forms.RouteSummaryStops.filterFromReports;
      if (filter) {
        App.Objects.RouteSummaryStops.getCriteriaToFilterFromReports(
          filter
        ).forEach(item => {
          criteria.criteriaChain[0].and.push(item);
        });
      }
      if (stopKey) {
        criteria.criteriaChain[0].and.push({
          attr: "stop.key",
          eq: stopKey,
          matchMode: Monet.Utils.CriteriaMatchModes.EXACT
        });
      }
      if (routeId) {
        criteria.criteriaChain[0].and.push({
          attr: "route.id",
          eq: routeId
        });
      }
    } else if (App.Forms.RouteSummaryStops.unsuccessfulDelivery) {
      const routeId = App.Forms.RouteSummaryStops.routeId;
      criteria.criteriaChain[0].and.push({
        attr: "route.id",
        eq: routeId
      });

      criteria.criteriaChain[0].and.push({
        or: [
          {
            attr: "stop.deliveryStatus",
            eq: "PARTIALLY_DELIVERED"
          },
          {
            attr: "stop.cancelCode.id",
            isNull: false
          }
        ]
      });

      App.Forms.RouteSummaryStops.unsuccessfulDelivery = false;
    }

    return criteria;
  };
}

App.Routers.RouteSummaryStops = RouteSummaryStopsRouter;
